export { default as AlgoliaIconicCarousel } from "./AlgoliaIconicCarousel";
